import {getShopName, JURISDICTIONS} from "../../../config";

function JurisdictionSelector(_props) {
  const jurisdictions = Object.values(JURISDICTIONS).map((id) => ({code: id, name: getShopName(id)}));
  jurisdictions.unshift({code: null, name: "Global"});

  // TODO import Dropdown component from shop
  // return (
  //   <ActionDropdownButton
  //     label=""
  //     options={fromJS(jurisdictions)}
  //     valueKey="code"  
  //     titleKey="name" 
  //     onClick={(e, opt) => setCurrentJurisdiction(opt)}
  //   />
  // )
  return null;
}

export default JurisdictionSelector;
// export default reduxForm({
//   form: "JurisdictionSelectorForm"
// })(JurisdictionSelector);